export default __webpack_public_path__ + "static/media/hotel1.ca24d128.JPG";